import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from '@mui/material';
import {
  DocumentScanner as DocumentScannerIcon,
  Search as SearchIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import { withDevice, WithDeviceProps } from '../hooks/withDevice';
import { useTranslation } from 'react-i18next';

interface FooterProps extends WithDeviceProps {}

const Footer: React.FC<FooterProps> = ({ isMobileDevice }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // Get current page index for bottom navigation
  const getCurrentPageIndex = () => {
    const path = location.pathname;
    if (path === '/') return 0;
    if (path === '/lanzamiento') return 1;
    if (path === '/settings') return 2;
    return 0;
  };

  const handleNavigationChange = (event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/');
        break;
      case 1:
        if (isMobileDevice) {
          navigate('/settings');
        } else {
          navigate('/lanzamiento');
        }
        break;
      case 2:
        navigate('/settings');
        break;
      default:
        break;
    }
  };

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        borderTop: '1px solid',
        borderColor: 'divider'
      }} 
      elevation={3}
    >
      <BottomNavigation
        value={getCurrentPageIndex()}
        onChange={handleNavigationChange}
        showLabels
        sx={{
          '& .MuiBottomNavigationAction-root': {
            color: 'text.secondary',
            '&.Mui-selected': {
              color: 'primary.main',
            },
          },
        }}
      >
        <BottomNavigationAction
          label={t('navigation.projects')}
          icon={<SearchIcon />}
        />
        {!isMobileDevice && <BottomNavigationAction
          label={'Lanzamiento'}
          icon={<DocumentScannerIcon />}
        />}
        <BottomNavigationAction
          label={t('navigation.settings')}
          icon={<SettingsIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default withDevice(Footer);
